import React, { CSSProperties } from 'react';
import SideNavContent from './sideNavContent';

export type layoutSideNavType = {
  sidebarStyle: CSSProperties;
  logoStyle: CSSProperties;
  logoSrc: string;
  isCollapsed: boolean;
};

const LayoutSideNav: React.FC<layoutSideNavType> = ({
  sidebarStyle,
  logoSrc,
  logoStyle,
  isCollapsed,
}) => {
  return (
    <div
      className="fixed top-0 left-0 flex flex-col justify-between h-screen px-4 py-2 bg-white transition-all duration-300"
      style={{ ...sidebarStyle, zIndex: 50 }}
    >
      <div className="flex flex-col gap-[37px]">
        {/* Logo */}
        <div className="flex items-center justify-between w-full px-4">
          <img
            src={logoSrc}
            alt="pozytron logo"
            className="shrink-0 transition-transform duration-500 ease-in-out"
            style={logoStyle}
          />
        </div>

        {/* Nav items */}
        <SideNavContent isIconOnly={isCollapsed} />
      </div>

      {!isCollapsed && (
        <img
          src="/navBarIllastration.svg"
          alt="pozytron logo"
          className="shrink-0"
        />
      )}
    </div>
  );
};

export default LayoutSideNav;
